(function(){
if(window.__quadroExtensionSourceReady)return;
window.__quadroExtensionSourceReady=true;


  var productSourceSwiperStates = new WeakMap();
  var productSourceActiveSwipers = new Set();
  var productSourceObservedSliders = new WeakSet();
  var productSourceResizeFrame = 0;
  var productSourceObserver = typeof IntersectionObserver === 'function'
    ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          productSourceObserver.unobserve(entry.target);
          productSourceActivateSlider(entry.target);
        }
      });
    }, { rootMargin: '400px 0px' })
    : null;

  function productSourceActivateSlider(container) {
    var activeIndex = productSourceCurrentSliderIndex(container);
    productSourceSetActiveSlide(container, activeIndex, false);
  }

  function productSourceScheduleSlider(container) {
    var bounds = container.getBoundingClientRect();
    if (!productSourceObserver || bounds.width > 0 && bounds.bottom >= -400 && bounds.top <= window.innerHeight + 400) {
      if (productSourceObserver) {
        productSourceObserver.unobserve(container);
      }
      productSourceActivateSlider(container);
    } else if (!productSourceObservedSliders.has(container)) {
      productSourceObservedSliders.add(container);
      productSourceObserver.observe(container);
    }
  }

  function productSourceScheduleResize() {
    if (productSourceResizeFrame) {
      return;
    }
    productSourceResizeFrame = window.requestAnimationFrame(function () {
      productSourceResizeFrame = 0;
      productSourceActiveSwipers.forEach(function (container) {
        if (!container.isConnected) {
          productSourceActiveSwipers.delete(container);
          return;
        }
        productSourceSetActiveSlide(container, productSourceCurrentSliderIndex(container), false);
      });
    });
  }

  function productSourceSliderIndex(index, length) {
    if (!length) {
      return 0;
    }

    return ((index % length) + length) % length;
  }

  function productSourceCurrentSliderIndex(container) {
    var value = parseInt(container.getAttribute('data-current-slide'), 10);
    return Number.isNaN(value) ? 0 : value;
  }

  function productSourceSetActiveSlide(container, index, animate) {
    var state = productSourceSwiperStates.get(container);
    if (!state) {
      state = {
        swiper: container.querySelector('.qks-swiper'),
        wrapper: container.querySelector('.swiper-wrapper'),
        slides: Array.prototype.slice.call(container.querySelectorAll('.swiper-slide')),
        bullets: Array.prototype.slice.call(container.querySelectorAll('.swiper-pagination-bullet'))
      };
      productSourceSwiperStates.set(container, state);
    }
    var swiper = state.swiper;
    var wrapper = state.wrapper;
    var slides = state.slides;
    var bullets = state.bullets;

    if (!swiper || !wrapper || !slides.length) {
      return;
    }

    var activeIndex = productSourceSliderIndex(index, slides.length);
    swiper.classList.add('swiper-initialized', 'swiper-horizontal');
    var width = Math.round(swiper.getBoundingClientRect().width || container.getBoundingClientRect().width);

    if (width <= 0) {
      return;
    }
    productSourceActiveSwipers.add(container);
    var sizeChanged = state.width !== width;
    var indexChanged = state.index !== activeIndex;
    if (!sizeChanged && !indexChanged) {
      return;
    }
    state.width = width;
    state.index = activeIndex;
    container.setAttribute('data-current-slide', String(activeIndex));
    wrapper.style.transitionDuration = animate ? '240ms' : '0ms';

    if (width > 0) {
      wrapper.style.transform = 'translate3d(' + (-width * activeIndex) + 'px, 0px, 0px)';
      if (sizeChanged) {
        slides.forEach(function (slide) {
          slide.style.width = width + 'px';
          slide.style.marginRight = '0px';
        });
      }
    }

    if (!indexChanged) {
      return;
    }
    slides.forEach(function (slide, slideIndex) {
      var active = slideIndex === activeIndex;
      slide.classList.toggle('swiper-slide-active', active);
      slide.classList.toggle('swiper-slide-next', slideIndex === productSourceSliderIndex(activeIndex + 1, slides.length));
      slide.classList.toggle('swiper-slide-prev', slideIndex === productSourceSliderIndex(activeIndex - 1, slides.length));
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    bullets.forEach(function (bullet, bulletIndex) {
      var active = bulletIndex === activeIndex;
      bullet.classList.toggle('swiper-pagination-bullet-active', active);
      bullet.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function productSourceInitializeSliders(root) {
    var scope = root || document;
    scope.querySelectorAll('.product-source .qks-swiper-container').forEach(productSourceScheduleSlider);
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) {
      return;
    }

    var tab = event.target.closest('.product-source .quadro-kit-tab');
    if (!tab) {
      var nextButton = event.target.closest('.product-source .qks-swiper-container > .swiper-button-next');
      var prevButton = event.target.closest('.product-source .qks-swiper-container > .swiper-button-prev');
      var bullet = event.target.closest('.product-source .qks-swiper-container .swiper-pagination-bullet');

      if (nextButton || prevButton || bullet) {
        var slider = event.target.closest('.qks-swiper-container');
        var currentIndex = productSourceCurrentSliderIndex(slider);
        event.preventDefault();

        if (nextButton) {
          productSourceSetActiveSlide(slider, currentIndex + 1, true);
        } else if (prevButton) {
          productSourceSetActiveSlide(slider, currentIndex - 1, true);
        } else {
          var bullets = Array.prototype.slice.call(slider.querySelectorAll('.swiper-pagination-bullet'));
          productSourceSetActiveSlide(slider, bullets.indexOf(bullet), true);
        }
      }

      return;
    }

    var tabs = tab.closest('.quadro-kit-tabs');
    var block = tabs ? tabs.parentElement : null;
    var panels = block ? block.querySelectorAll('.quadro-kit-tabs-body > .quadro-kit-tab-content') : [];
    var targetId = tab.getAttribute('aria-controls');

    tabs.querySelectorAll('.quadro-kit-tab').forEach(function (item) {
      var active = item === tab;
      item.classList.toggle('quadro-kit-tab-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
      item.setAttribute('tabindex', active ? '0' : '-1');
    });

    panels.forEach(function (panel) {
      var active = panel.id === targetId;
      panel.classList.toggle('quadro-kit-tab-active', active);
    });

    window.requestAnimationFrame(function () {
      productSourceInitializeSliders(block);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (!event.target.closest) {
      return;
    }

    var tab = event.target.closest('.product-source .quadro-kit-tab');
    if (tab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) !== -1) {
      var tabList = tab.closest('.quadro-kit-tabs');
      var tabs = Array.prototype.slice.call(tabList.querySelectorAll('.quadro-kit-tab'));
      var currentIndex = tabs.indexOf(tab);
      var nextIndex = currentIndex;

      if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      } else if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = tabs.length - 1;
      }

      event.preventDefault();
      tabs[nextIndex].focus();
      tabs[nextIndex].click();
      return;
    }

    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    var control = event.target.closest('.product-source .swiper-button-next, .product-source .swiper-button-prev, .product-source .swiper-pagination-bullet');
    if (!control) {
      return;
    }

    event.preventDefault();
    control.click();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      productSourceInitializeSliders(document);
    });
  } else {
    productSourceInitializeSliders(document);
  }

  window.addEventListener('load', productSourceScheduleResize);
  window.addEventListener('resize', productSourceScheduleResize);
  document.addEventListener('shopify:section:load', function (event) {
    productSourceInitializeSliders(event.target);
  });

})();
